/* global axios */

import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true });
  }

  getBoard() {
    return axios.get(`${this.url}/board`);
  }

  getNewConversations({ cursor, limit = 50 } = {}) {
    const params = { limit };

    if (cursor) {
      params.cursor = cursor;
    }

    return axios.get(`${this.url}/novo`, { params });
  }

  createCard(data) {
    return axios.post(`${this.url}/cards`, data);
  }

  moveCard(cardId, data) {
    return axios.patch(`${this.url}/cards/${cardId}/move`, data);
  }

  deleteCard(cardId) {
    return axios.delete(`${this.url}/cards/${cardId}`);
  }

  moveColumn(columnId, data) {
    return axios.patch(`${this.url}/columns/${columnId}/move`, data);
  }

  updateColumn(columnId, data) {
    return axios.patch(`${this.url}/columns/${columnId}`, data);
  }
}

export default new KanbanAPI();
